var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div ng-transclude=\"label\" class=\"{{::$ctrl.labelClass}}\"><strong class=\"text-{{::$ctrl.labelColor || 'default'}}\">{{::$ctrl.label + ($ctrl.label?':':'')}}</strong></div><div class=\"{{::$ctrl.valueClass}}\"><div ng-transclude=\"\"><span class=\"text-{{::$ctrl.valueColor || 'default'}}\">{{$ctrl.value}}</span></div><div ng-transclude=\"value\"></div></div>";
var id1="datum-stacked.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;